<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-4"></a>
<div class="img_container"><img alt="image" class="width" src="images/Img_1_001.jpg"/></div>
<p class="ded"><em class="italic">For Marie and Melanie</em></p>
<p class="copy1">CIS0019</p>
<p class="copy1">Print Edition: ISBN 978-1-61200-9087</p>
<p class="copy">Digital Edition: ISBN 978-1-61200-9094</p>
<p class="copy1">© Casemate Publishers 2020</p>
<p class="copy1">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the publisher in writing.</p>
<p class="copy1">Design by Battlefield Design</p>
<p class="copy">Color profiles by Ronny Bar</p>
<p class="copy1">CASEMATE PUBLISHERS (US)</p>
<p class="copy">Telephone (610) 853-9131</p>
<p class="copy">Fax (610) 853-9146</p>
<p class="copy">Email: <span class="weblink"><a href="http://casemate@casematepublishers.com" target="_blank"><span class="underline">casemate@casematepublishers.com</span></a></span></p>
<p class="copy"><span class="weblink"><a href="http://www.casematepublishers.com" target="_blank"><span class="blue"><span class="underline">www.casematepublishers.com</span></span></a></span></p>
<p class="copy1">CASEMATE PUBLISHERS (UK)</p>
<p class="copy">Telephone (01865) 241249</p>
<p class="copy">Fax (01865) 794449</p>
<p class="copy">Email: <span class="weblink"><a href="http://casemate-uk@casematepublishers.co.uk" target="_blank"><span class="underline">casemate-uk@casematepublishers.co.uk</span></a></span></p>
<p class="copy"><span class="weblink"><a href="http://www.casematepublishers.co.uk" target="_blank"><span class="underline">www.casematepublishers.co.uk</span></a></span></p>
<p class="copy1">Photo credits: Scott Pick WWII Russian Front Original Photo Collection—via Anthony Tucker-Jones, San Diego Air and Space Museum, Russian Ministry of Defense, Russian Air Force, German Federal Archives, Polish National Archives, Hungarian National Archives, United States Air Force, Finnish Wartime Photograph Archive—SA kuva, Russian International News Agency (RIA Novosti), Corwin-Kerber, Ovcharenko Archive, Bedin Denis Yurevich, Suren Migranovich Kafafyan, Medin Robănescu.</p>
<p class="copy2">Title page: Stukas in flight over the Eastern Front, December 22, 1943.</p>
<p class="copy3">Contents page: : Il-2s in action over the Kursk salient.</p>
<p class="copy3">Map: The disposition of the Luftwaffe’s expeditionary forces on the eve of Operation <em class="italic">Barbarossa</em>, the German invasion of the Soviet Union. The combined forces were sufficient to penetrate deep into the Soviet homeland, but as the harsh Russian winter descended upon the Luftwaffe (and the Soviets began rolling back Nazi forces), the Luftwaffe had to divert many of its assets from the North African theater.</p>
<p class="copy2">Note: aircraft illustrations and profiles are not to scale.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Copyright.vue?7d0926e4